<template>
  <div
    class="flex flex-col w-full min-h-[6.5rem] border rounded-md shadow p-4 gap-2 relative overflow-hidden dark:border-neutral-700 dark:text-neutral-300"
  >
    <div
      v-if="lead.is_won !== null"
      class="absolute -top-1 -right-[68px] mr-1 bg-red-600 text-white text-xs font-semibold w-40 pb-1 pt-6 transform rotate-45 text-center shadow-lg"
    >
      Archived
    </div>
    <div class="flex justify-between">
      <div class="flex items-center gap-2">
        <Icon
          icon="mynaui:users"
          class="rounded-full text-4xl p-2 text-[#FDB951] bg-[#FEF5E5]"
        />
        <div class="flex flex-col gap-2">
          <a :href="`/leads/${lead?.id}`" target="_blank" class="text-base text-wrap max-w-40">{{ lead.pipeline.name }}</a>
          <p class="text-xs text-gray-500">لید شماره #{{ lead.id }}</p>
        </div>
      </div>
      <div class="flex gap-2">
        <span class="text-sm text-gray-500 text-nowrap">{{
          toPersianDate(lead.updated_at)
        }}</span>
      </div>
    </div>
    <div class="flex gap-2 flex-wrap">
      <div
        v-for="(tag, index) in lead.tags"
        :key="index"
        class="text-white text-[10px] px-2 py-1 rounded-2xl text-nowrap bg-blue-primary"
      >
        {{ tag.name }}
      </div>
      <div
        v-if="packageType && packageType?.value"
        class="text-white text-[10px] px-2 py-1 rounded-2xl text-nowrap bg-gradient-to-l from-blue-400 to-orange-400"
      >
        {{ packageType.value }}
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, defineProps } from "vue";
import { Icon } from "@iconify/vue";
import moment from "jalali-moment";

const props = defineProps({
  lead: {
    type: Object,
    required: true,
  },
});

const attribute_values = computed(() => props.lead?.attribute_values);
const packageType = computed(() =>
  attribute_values?.value?.find((av) => av.attribute_lead_id === 9)
);
function toPersianDate(gregorianDate) {
  const date = moment(gregorianDate);
  const persianDate = date.format("jYYYY/jMM/jDD HH:mm:ss");
  const persianDigits = ["۰", "۱", "۲", "۳", "۴", "۵", "۶", "۷", "۸", "۹"];
  return persianDate.replace(/\d/g, (digit) => persianDigits[digit]);
}
</script>
